import User from "@/utils/user";

/** HYC 财务沿用现有财务部账单权限；额度配置等原有权限由调用方明确传入。 */
export function canHycFinance(action = "manage_bill") {
    return User.isSuperAdmin() || (User.getPermission() || []).some((item) => item.action === action);
}

/** 客服代申请沿用售后部权限，财务处理权限保持独立。 */
export const canHycCustomerRefund = () => canHycFinance("manage_after_sale");
export const canReadHycRefunds = () => canHycCustomerRefund() || canHycFinance();

// 客服从组织管理进入单个客户账务，不授予整套财务模块权限。
export const canReadHycCustomerAccount = () => canHycFinance("manage_after_sale") || canHycFinance("manage_bill");
export const canManageHycExclusive = () => canReadHycCustomerAccount();
